/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An evaluable fact about a data entry.
 */
export interface AnalyticMeasure { 
    /**
     * Internal AnalyticMeasure Key
     */
    id?: number;
    /**
     * Internal AnalyticValue Key
     */
    analyticValueId?: number;
    /**
     * Internal AnalyticMeasureType Key
     */
    analyticMeasureTypeId?: number;
    /**
     * The value of the evaluable fact
     */
    value?: number;
}

